/**
 * Die zwei Kennsätze einer Person (Spec 25, Oberfläche B/D) — geteilt
 * zwischen der Personenliste (`routes/Access.tsx`, mit `<id>`) und der
 * Personenansicht (`routes/AccessUser.tsx`, ohne `<id>`, weil dort nur eine
 * Person steht). Bauform wie „Intern"/„Extern" bzw. der Vorschlag-Kennsatz
 * aus Spec 24c (`DocumentRow.tsx::HintBadge`) — 1px Rahmen, `text-label`.
 *
 * **D2 (Entscheidung Lukas):** „Vollzugriff" trägt Akzent (Rahmen und Text),
 * „Gesperrt" bleibt `muted` — die gedämpfte Zeile selbst trägt die Sperre
 * schon, der Kennsatz nennt nur das Wort.
 */

export function FullAccessBadge({ testId }: { readonly testId: string }) {
  return (
    <span data-testid={testId} className="border-accent text-accent text-label rounded-card shrink-0 border px-1.5 py-0.5">
      Vollzugriff
    </span>
  )
}

export function DisabledBadge({ testId, label }: { readonly testId: string; readonly label: string }) {
  return (
    <span data-testid={testId} className="border-border text-muted text-label rounded-card shrink-0 border px-1.5 py-0.5">
      {label}
    </span>
  )
}
